<template>
    <div class="chosedialog">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog xuanzewuliao" width="70%" append-to-body>
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon yxline">
                        <div class="h-formbLine" style="margin-bottom: 1px;">
                            <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" @submit.native.prevent style="margin-left:-0.5rem">
                                <el-form-item label="订单号" >
                                    <el-input clearable v-model="q.cgCode"></el-input>
                                </el-form-item>
                                <el-form-item label="公司主体" style="width: 400px;">
                                    <brselect category="kkber_value" v-model="q.companyCode"
                                            :v="q.companyCode" @change="handleFilter"></brselect>
                                </el-form-item>
                                <el-form-item  >
                                    <el-button class="w-tongyi" type="primary"  @click="handleFilter">搜索</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <el-table
                                max-height="500px"
                                size="mini"
                                ref="multipleTable"
                                :data="ttdata"
                                :border="true"
                                tooltip-effect="dark"
                                style="width: 100%"
                                @selection-change="handleSelectionChange">
                            <el-table-column
                                    type="selection"
                                    fixed
                                    width="55">
                            </el-table-column>
                            <el-table-column
                                    prop="orderDate"
                                    label="订单日期"
                                    width="110"
                                    :formatter="formatDate"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="cgCode"
                                    label="订单号"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="orderNumber"
                                    label="sap订单号"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>

                            <el-table-column
                                    prop="org"
                                    label="采购组织"
                                    width="80"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="orderQuantity"
                                    label="订单数量"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="taxCode"
                                    label="税率"
                                    width="80">
                                <template slot-scope="scope">
                                    <dictname category="cgshuilv"  :v="scope.row.taxCode"/>
                                </template>
                            </el-table-column>

                            <el-table-column
                                    prop="currency"
                                    label="币种"
                                    width="80"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="amount"
                                    label="订单金额"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="includeTaxAmount"
                                    label="订单含税金额"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="supplierCode"
                                    label="供应商编号"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="companyCode"
                                    label="公司主体"
                                    width="220"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <dictname category="kkber_value"  :v="scope.row.companyCode"/>
                                </template>
                            </el-table-column>


                        </el-table>
                        <div style="justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                           <span>合计金额：</span><span style="color: red">{{totalMoney}}</span>
                        </div>
                        <el-form :inline="true"  class="demo-form-inline h-formBorder tan" >
                            <el-form-item label="申请附件" class="h-elformWrap-2" prop="upload1" >
                                <el-upload

                                        ref="formLabel"
                                        class="upload-demo"
                                        action=""
                                        :on-preview="handlePreview"
                                        :http-request="httpRequest"
                                        :on-remove="handleRemove"
                                        :multiple=false
                                        :file-list="fileList"
                                        :auto-upload=true>
                                    <el-button size="small" type="primary">点击上传</el-button>
                                </el-upload
>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="h-txtCenter h-mrt60" style="margin: 1rem auto 0 auto;">
                        <el-button  class="h-btn h-bBtn h-bgblue2" @click="saveTo">保存</el-button>
                        <el-button  class="h-btn h-bBtn h-bgblue2" @click="subTo">提交</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    import uploadFile from "../../api/process/account_complainUploadService";
    import big from 'big.js'

    export default {
        name: "alluser",
        data(){
            return {
                q:{
                    companyCode:'',
                    cgCode:''
                },
                ttdata:[],
                lists:[],
                totalMoney:0,
                userRole: '',
                form:{},
                fileList:[],
                refid:'',
                includeTaxAmount:0,
            }
        },
        methods: {
            handleFilter(){
                this.querypage();
            },
            querypage(){
                if(!this.q.companyCode){
                    this.$message.error('请先选择公司主体');
                    return;
                }
                ss.invoiceApplyList.selectUnInvoice(this.q).then(rd=>{
                    this.ttdata = rd.list;

                    // this.userRole = this._user.roles;
                    // this.userRole.forEach((item, index) => {
                    //     if (item.id == "swyl_dailishang") {
                    //         this.dailishangFlag = false;
                    //     }
                    // })
                })
            },
            handleSelectionChange(lists){
                this.totalMoney=0.0;
                this.includeTaxAmount=0.0;
                for(var i=0;i<lists.length;i++){
                    this.totalMoney=new big(this.totalMoney).plus(lists[i].amount);
                    this.includeTaxAmount=new big(this.includeTaxAmount).plus(lists[i].includeTaxAmount);
                }
                this.lists = lists;

            },
            saveTo(){
                if(!this.q.companyCode){
                    this.$message.error("必须选择公司主体！");
                    return;
                }
                if(this.lists.length==0){
                    this.$message.error("必须选择明细！");
                    return;
                }
                for(var i=0;i<this.lists.length;i++){
                    if(this.lists[0].taxCode!=this.lists[i].taxCode){
                        this.$message.error("税额必须一致！");
                        return;
                    }
                    if(this.lists[0].currency!=this.lists[i].currency){
                        this.$message.error("币种必须一致！");
                        return;
                    }

                }
                this.form.companyCode=this.q.companyCode;
                if(this.fileList.length>0) {
                    this.form.fileName = this.fileList[0].name;
                    this.form.fileUrl = this.fileList[0].saveurl;
                    this.form.fileId = this.fileList[0].id;
                }
                this.form.list=this.lists;
                this.form.totalMoney=this.totalMoney;
                this.form.taxCode=this.lists[0].taxCode;
                this.form.currency=this.lists[0].currency;
                this.form.includeTaxAmount=this.includeTaxAmount;
                ss.invoiceApplyList.saveApply(this.form).then(rd=> {
                    if(rd.f){
                        this.$message.success("保存成功");
                        this.$emit('saveorsubmit')
                    }else{
                        this.$message.error(rd.msg);
                    }
                });
            },
            subTo(){
                if(!this.q.companyCode){
                    this.$message.error("必须选择公司主体！");
                    return;
                }
                if(this.lists.length==0){
                    this.$message.error("必须选择明细！");
                    return;
                }
                for(var i=0;i<this.lists.length;i++){
                    if(this.lists[0].taxCode!=this.lists[i].taxCode){
                        this.$message.error("税额必须一致！");
                        return;
                    }
                    if(this.lists[0].currency!=this.lists[i].currency){
                        this.$message.error("币种必须一致！");
                        return;
                    }
                }
                this.form.companyCode=this.q.companyCode;
                if(this.fileList.length>0) {
                    this.form.fileName = this.fileList[0].name;
                    this.form.fileUrl = this.fileList[0].saveurl;
                    this.form.fileId = this.fileList[0].id;
                }
                this.form.list=this.lists;
                this.form.totalMoney=this.totalMoney;
                this.form.taxCode=this.lists[0].taxCode;
                this.form.currency=this.lists[0].currency;
                this.form.includeTaxAmount=this.includeTaxAmount;
                ss.invoiceApplyList.subApply(this.form).then(rd=> {
                    if(rd.f){
                        this.$message.success("提交成功");
                        this.$emit('saveorsubmit')
                    }else{
                        this.$message.error(rd.msg);
                    }
                });

            },
            httpRequest(params) {
                // console.log(params,"1111111111")
                const loading = this.$msg.loading("上传中...");
                uploadFile.upload(params.file, {companycode: this.refid, reftype: '发票申请单'}).then(rd => {
                    console.log("上传完毕后", rd);
                    loading.close();
                    this.fileList=[];
                    this.fileList.push(rd.obj);

                }).catch(error => {
                    loading.close();
                    this.fileList.splice(0, 1);
                    return Promise.reject(error);
                });
                return false;
            },
            handleRemove(file) {
                console.log(file, "aaaaa");
                //删除文件
                var id = file.id;
                uploadFile.deleteById(id).then(response => {
                    this.fileList=[];
                })

            },
            beforeRemove(file) {
                return this.$confirm(`确定移除 ${ file.name }？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                });
            },

            //方法区
            formatDate(row, column) {
                // 获取单元格数据
                let date = row[column.property];
                if (date) {
                    return this.transformDate(date)
                } else {
                    return ''
                }
            },
            //标准时间格式转yyyy-MM-dd
            transformDate(date) {
                if (date) {
                    let dt = new Date(date);
                    return dt.getFullYear() + '-' +
                        ((dt.getMonth() + 1) < 10 ? ('0' + (dt.getMonth() + 1)) : (dt.getMonth() + 1)) + '-' +
                        (dt.getDate() < 10 ? ('0' + dt.getDate()) : dt.getDate());
                } else {
                    return ''
                }
            },
            handlePreview(file){

                window.open(file.saveurl);
            }


        },
        created(){
            this.refid = this.$util.getUuid();
        },

        computed: {

        },
        props: {
            dialogVisible: {
                type: Boolean,
            },

        }
    }
</script>

<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
    .w-tongyi {
        padding: 0.1rem 0.25rem;
    }
    .tan.h-formBorder .h-elformWrap-2{
        width: 50%;
    }
    .tan.h-formBorder .h-elformWrap-2 .el-form-item__label{
        width: 22%;
    }
    .tan.h-formBorder .h-elformWrap-2 .el-form-item__content{
        width: 78%;
    }
    /deep/.el-upload-list__item.is-success.focusing .el-icon-close-tip{
        　　display: none !important;
    }
</style>
